import { ActivateDebitCardErrorEnum } from 'types/gql-global-types'
import {
  ActivateDebitCard_activateDebitCard as ActivateDebitCardResult,
  ActivateDebitCard_activateDebitCard_ActivateDebitCardError as ApiError,
  ActivateDebitCard_activateDebitCard_DebitCardV2 as DebitCardV2,
} from 'types/gql-types/ActivateDebitCard'

export const SUPPORTED_ERRORS = Object.values(ActivateDebitCardErrorEnum)

export const getIsApiError = (
  result: ActivateDebitCardResult
): result is ApiError => Boolean((result as ApiError).error)

export const getIsDebitCardV2 = (
  maybeDebitCardV2:
    | DebitCardV2
    | ActivateDebitCardErrorEnum
    | ActivateDebitCardResult
): maybeDebitCardV2 is DebitCardV2 =>
  Boolean((maybeDebitCardV2 as DebitCardV2).id)
